import { useContext } from 'react';
import { ToastContext, ToastContextInterface } from '@/contexts/toasts/toast-context';

export default function useToasts() {
  const { setToast, getToast, deleteToast, toasts } = useContext<ToastContextInterface>(ToastContext);

  return {
    setToast,
    getToast,
    deleteToast,
    toasts,
  };
}
